// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iv","advertCardHeader__actions":"c-a_iw","advertCardHeader__bottomLabel":"c-a_ix"};